module.exports = __webpack_public_path__ + "static/media/HTA-1.d9e6e824.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/wardrober/src/HTA-1.png
// module id = 193
// module chunks = 0